import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import HomeContainer from "./HomeContainer";

export default () => {
  const { isProtected, checkRoles } = { ...AppRoutingRoles[AppRouteURI.HOME] };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <HomeContainer />
    </App>
  );
};
